<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="姓名">
      <el-input v-model="queryParam.realname" placeholder="输入姓名" />
    </el-form-item>
    <el-form-item label="昵称">
      <el-input v-model="queryParam.nickname" placeholder="输入昵称" />
    </el-form-item>
    <el-form-item label="学校">
      <el-input v-model="queryParam.school" placeholder="学校名称" />
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="神兽状态" style="width:120px">
        <el-option label="正常" :value="1" />
        <el-option label="停用" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="getListShenshou">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="primary"
          @click="(dialog = true), doShenshouAdd()"
          v-hasPermission="['shenshou:add']"
          >新增神兽</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table ref="tableRef" v-loading="loadingData" :data="tableData" class="mainTable">
        <el-table-column prop="realname" label="姓名" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column prop="grade" label="年级/班级">
          <template #default="scope">
            {{ util.showGrade(scope.row.grade) }}（{{ util.showClass(scope.row.classes)}}）
          </template>
        </el-table-column>
        <el-table-column prop="school" label="学校" />
        <el-table-column prop="status" label="状态" >
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showCommonStatus(scope.row.status)"></span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template #default="scope">
            <el-link
              type="primary"
              @click="open('score', scope.row)"
              v-hasPermission="['score']"
              >成绩</el-link>

              <el-link
              type="primary"
              @click="open('shenshou:stat', scope.row)"
              v-hasPermission="['shenshou:stat']"
              >统计</el-link>

              <el-link
              type="primary"
              @click="openGrowth('growth', scope.row)"
              v-hasPermission="['growth']"
              >历程</el-link>

            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doShenshouEdit(scope.$index, scope.row)"
              v-hasPermission="['shenshou:edit']"
              >编辑</el-link
            >

            <el-popconfirm
              confirm-button-type="primary"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定删除吗？"
              width="200px"
              @confirm="doShenshouDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                  size="small"
                  type="danger"
                  v-hasPermission="['shenshou:delete']"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8">
      <!-- <div>
        <el-button type="primary">新增神兽</el-button>
      </div> -->
    </el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="false"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :title="title"
    direction="rtl"
    :close-on-click-modal="false"
    size="45%"
    @close="doShenshouClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="shenshouFormRef"
        :model="shenshouForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="姓名" prop="realname">
          <el-input
            v-model.trim="shenshouForm.realname"
            placeholder="请输入神兽姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input
            v-model.trim="shenshouForm.nickname"
            placeholder="请输入神兽昵称"
          ></el-input>
        </el-form-item>
        
       
        <el-form-item label="头像" prop="avatar">
          <el-upload
            class="upload-demo"
            action="/api/upload/common"
            :auto-upload="true"
            :headers="headerUpload"
            :on-success="doUploadSuccess"
            :before-upload="beforeUpload"
            accept="image/png, image/jpeg, image/jpg"
            name="picture"
          >
          <template #trigger>
            <el-button type="primary">选择头像</el-button>
          </template>
           
            <template #tip>
              <div class="el-upload__tip">
                请上传PNG、JPEG、JPG后缀名且小于1M的文件。
              </div>
            </template>
          </el-upload>
          <el-image v-if="shenshouForm.avatar" style="width: 120px;display: block;" :src="shenshouForm.avatar" />
        </el-form-item>
        <el-form-item label="学号" prop="sids">
          <el-input
            v-model.number="shenshouForm.sids"
            placeholder="请输入学号"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="shenshouForm.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出生日期" prop="birth">
          <el-date-picker
            v-model="shenshouForm.birth"
            type="date"
            placeholder="请选择出生日期"
            :default-value="new Date(2010, 10, 1)"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="年级" prop="grade">
          <el-select v-model="shenshouForm.grade" placeholder="选择年级" style="width: 100%;">
            <el-option
              v-for="item in gradeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="班级" prop="classes">
          <el-select v-model="shenshouForm.classes" placeholder="选择班级" style="width: 100%;">
            <el-option
              v-for="item in classData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学校" prop="school">
          <el-input
            v-model.trim="shenshouForm.school"
            placeholder="请输入学校全称，如何黄浦第一实验小学"
          ></el-input>
        </el-form-item>
        <el-form-item label="神兽介绍" prop="content">
          <el-input
            v-model="shenshouForm.content"
            placeholder="请输入神兽介绍"
            type="textarea"
            autosize
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="shenshouForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doShenshouClose()">关闭</el-button>
        <el-button type="primary" :loading="loading" @click="doShenshouSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listShenshou, deleteShenshou, saveShenshou } from "@/api/shenshou";//changeShenshouStatus
import { useRouter } from "vue-router";

import util from "@/util/tool.js";
import store from "@/store";
import storage from "@/util/storage.js";


import config from "@/util/config.js";



const router = useRouter();

let timer;

const dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const tableData = ref();
const total = ref(0);
const pageSize = ref(15); //每页显示条数

let shenshouFormRef = ref();
let title = ref("新增神兽");

let open = (routeName, row) => {
  storage.saveSessionObject("shenshouPath",queryParam.value)
  router.push({
    name: routeName,
    params: { id: row.shenshouid },
    query: {  userid: row.userid, realname: row.realname },
  });
};

let openGrowth = (routeName, row) => {
  storage.saveSessionObject("shenshouPath",queryParam.value)
  router.push({
    name: routeName,
    query: {  userid: row.userid, shenshouid: row.shenshouid,realname: row.realname },
  });
};


const gradeData = config.configGradeData;
const classData = config.configClassData;
// console.log(gradeData)
// console.log(gradeData)

//onMounted方法
onMounted(() => {
  getListShenshou();
});

const wxuserid = ref(router.currentRoute.value.query.userid);

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  userid: wxuserid.value,
  status: "",
  created: "",
  changed: "",
  realname: "",
  nickname: "",
  school: "",
});
const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    userid: wxuserid.value,
    status: "",
    created: "",
    changed: "",
    realname: "",
    nickname: "",
    school: ""
  };
  getListShenshou();
};

//神兽表单项
let shenshouForm = ref({
  shenshouid: null,
  userid:"",
  realname: "",
  nickname: "",
  sids: "",
  sex: 1,
  birth: "",
  grade: "",
  classes: "",
  school: "",
  avatar: "",
  content: "",
  status:1
});

//新增神兽
const doShenshouAdd = () => {
  title.value = "新增神兽";
  resetForm();
};

//编辑神兽
const doShenshouEdit = (index, obj) => {
  title.value = "编辑神兽";

  shenshouForm.value = {
    userid: obj.userid,
    shenshouid: obj.shenshouid,
    realname: obj.realname,
    nickname: obj.nickname,
    avatar: obj.avatar,
    sids: obj.sids,
    sex: obj.sex,
    birth: obj.birth,
    grade: obj.grade,
    classes: obj.classes,
    school: obj.school,
    content: obj.content,
    status: obj.status,
  };
  console.log(shenshouForm.value)
};
const resetForm = () => {
  shenshouForm.value = {
    shenshouid: null,
    userid:"",
    realname: "",
    nickname: "",
    sids: "",
    sex: 1,
    birth: "",
    grade: "",
    classes: "",
    school: "",
    avatar: "",
    content: "",
    status:1
  };
};

//关闭神兽表单弹窗
const doShenshouClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  shenshouFormRef.value.resetFields()
};

//保存神兽数据
const doShenshouSave = () => {
  shenshouFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    saveShenshou(shenshouForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListShenshou();
          doShenshouClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新神兽状态
const doShenshouDelete = (index, obj) => {
  // console.log('obj.shenshouid',obj.shenshouid.toString())
  deleteShenshou(obj).then((res) => {
    // console.log(res);
    if (res.data.code === 1) {
      getListShenshou();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListShenshou();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListShenshou();
};

//神兽列表API
const getListShenshou = () => {
  listShenshou(queryParam.value).then((res) => {
    tableData.value = res.data.extend.pages.list;
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    loadingData.value = false
  });
};

//神兽表单验证规则
const rules = ref({
  realname: [
    {
      required: true,
      message: "请输入神兽姓名",
      trigger: "blur",
    },
    {
      min: 2,
      max: 30,
      message: "神兽姓名长度2到30",
      trigger: "blur",
    },
  ],
  nickname: [
    {
      required: true,
      message: "请输入神兽昵称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 30,
      message: "神兽昵称长度2到30",
      trigger: "blur",
    },
  ],
  birth: [
    {
      required: true,
      message: "请选择出生日期",
      trigger: "blur",
    }
  ],
  grade: [
    {
      required: true,
      message: "请选择年级",
      trigger: "blur",
    }
  ],
  classes: [
    {
      required: true,
      message: "请选择班级",
      trigger: "blur",
    }
  ],
  school: [
    {
      required: true,
      message: "请输入学校",
      trigger: "blur",
    },
    {
      min: 2,
      max: 100,
      message: "学校长度2到100",
      trigger: "blur",
    },
  ],
  
  
});


const filefail = ref("");

const resultMsg = ref();
const doUploadSuccess = (response) => {  
  if (response.code === 0) {    
    ElMessage.error(response.msg)
  } else {
    resultMsg.value = response.msg
    filefail.value = response.url
    shenshouForm.value.avatar = response.url
    // console.log(res)
    //resultMsg.value = response.extend.goods
  }
};
const beforeUpload = (rawFile) => {
  //image/png, image/jpeg, image/jpg
  if (rawFile.type !== 'image/png' && rawFile.type !=='image/jpeg' && rawFile.type !=='image/jpg') {
    ElMessage.error('请上传PNG、JPEG、JPG格式图片!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 1) {
    ElMessage.error('请上传小于1MB的文件!')
    return false
  }
  resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
  return true
}
const headerUpload = ref({
  Authorization: store.state.user.token,
});

</script>
